module.exports = "pegasus/assets/preview-5.png";